import { render, staticRenderFns } from "./onlineBetting.vue?vue&type=template&id=3946b11e"
import script from "./onlineBetting.vue?vue&type=script&lang=js"
export * from "./onlineBetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports